import React from 'react'

const ViolationsTrackingPage = () => {
  return (
    <div>ViolationsTrackingPage</div>
  )
}

export default ViolationsTrackingPage